import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import SectionTitle from './SectionTitle';

function NotFound() {
  return (
    <div className='container notfound'>
      <Seo
        title="Page introuvable"
        description="La page demandée n'existe pas ou a été déplacée."
        noindex
      />
      <SectionTitle as="h1" overline="Erreur 404">Page introuvable</SectionTitle>
      <p>La page que vous cherchez n'existe pas ou a été déplacée.</p>
      <Link className="btn btn-primary" to="/">Retour à l'accueil</Link>
    </div>
  );
}

export default NotFound;
